module.exports = __webpack_public_path__ + "static/media/bg_card_3_wap.55304344.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/pageLargeModelSecurity/bg_card_3_wap.png
// module id = 140
// module chunks = 0